import { ModalManager } from "@/react/components/Layout/ModalManagerProvider";
import { useAcceptConnectionForUser } from "@/react/components/ProfileModalV3/Body/ConnectBanner/useAcceptConnectionForUser";
import { useIgnoreConnectionForUser } from "@/react/components/ProfileModalV3/Body/ConnectBanner/useIgnoreConnectionForUser";
import { AcceptConnectionMomentumModal } from "@/react/components/shared/MembersList/CommunityMembers/ActionButtons/AcceptConnectionMomentumModal";
import { useCircleV4 } from "@/react/hooks/useCircleV4";

import type { AcceptIgnoreButtonsProps } from "../types";
import { ConnectIconButtons } from "./ConnectIconButtons";
import { ConnectUiKitButtons } from "./ConnectUiKitButtons";
import { ConnectV4Buttons } from "./ConnectV4Buttons";

export const AcceptIgnoreButtons = ({
  connectionId,
  recipient,
  showMomentumModal = true,
  acceptButtonPosition = "right",
  size = "md",
  iconOnly = false,
  fullWidth = false,
  className,
}: AcceptIgnoreButtonsProps) => {
  const { isCircleV4 } = useCircleV4();
  const initiator = {
    first_name: recipient.first_name ?? "",
    id: recipient.id,
    public_uid: recipient.public_uid ?? "",
  };

  const { acceptConnectionForUser, isAccepting } = useAcceptConnectionForUser({
    initiator,
    onSuccess: () => {
      if (showMomentumModal && recipient.name && connectionId) {
        void ModalManager.show(AcceptConnectionMomentumModal, {
          recipient,
        });
      }
    },
  });

  const { ignoreConnectionForUser, isIgnoring } = useIgnoreConnectionForUser({
    initiator,
  });

  const handleIgnore = () => {
    if (!connectionId) return;
    ignoreConnectionForUser(connectionId);
  };

  const handleAccept = () => {
    if (!connectionId) return;
    acceptConnectionForUser(connectionId);
  };

  if (!recipient.first_name || !recipient.public_uid) {
    return null;
  }

  const flexDirection: "flex-row" | "flex-row-reverse" =
    acceptButtonPosition === "left" ? "flex-row" : "flex-row-reverse";
  const sharedProps = {
    handleAccept,
    handleIgnore,
    isAccepting,
    isIgnoring,
    flexDirection,
    className,
  };

  if (iconOnly) return <ConnectIconButtons {...sharedProps} />;
  if (isCircleV4)
    return <ConnectV4Buttons {...sharedProps} fullWidth={fullWidth} />;
  return <ConnectUiKitButtons {...sharedProps} size={size} />;
};
